export default "__VITE_ASSET__CKM5DabQ__"